import { gql } from '@apollo/client'

export const CONTENT_LIST_QUERY = gql`
  query ContentList(
    $language: String = "en"
    $offset: Int = 0
    $limit: Int = 25
    $order: [[String]]
    $where: ContentWhereInput = {}
    $references: [ContentContentReferencesToFilterInput] = []
    $referencesEvery: [ContentContentReferencesToFilterInput] = []
    $contentProviders: [ContentContentProviderFilterInput] = []
    $contentProvidersNot: [ContentContentProviderFilterInput] = []
  ) {
    contentList(
      offset: $offset
      limit: $limit
      order: $order
      where: $where
      references: $references
      referencesEvery: $referencesEvery
      contentProviders: $contentProviders
      contentProvidersNot: $contentProvidersNot
    ) {
      count
      limit
      offset
      content {
        id
        titleGroupId
        titleId
        contentId
        contentType
        language
        title
        path
        published
        publishedAtDate
        unpublishedAt
        contentReferencesFrom {
          id
          contentTo(language: [$language, "_primary"]) {
            language
            titleGroupId
            title
          }
          contentReferenceType {
            id
            type
          }
        }
        courseModuleRefs: contentReferencesFrom(
          types: ["course-module-practice", "course-module-other"]
        ) {
          contentTo(language: [$language, "_primary"]) {
            titleGroupId
            title
            contentId
            contentType
            courseRef: contentReferencesFrom(types: ["course-module"]) {
              contentTo(language: [$language, "_primary"]) {
                titleGroupId
                title
                contentId
                contentType
              }
            }
          }
        }
        contentAssetReferences {
          asset {
            mimeType
            originalFileName
          }
        }
        episodeNumber
        seasonNumber
        contentPolicyPolicyId
        primaryLanguage
        contentSearchNoIndex
        excludeFromRecommendations
        filterType
        bundle
        displayType
        productType
        weight
        familyFriendly
        seoTitle
        seoDescription
        seoCanonicalUrl
        seoKeywords
        seoRobotsNoFollow
        seoRobotsNoIndex
        previewMediaId
        featureMediaId
        dayNumber
        productionStatus
        instructor
        director
        producer
        writer
        cast
        copyright
        studio
        description
        descriptionFormat
        shortDescriptionFormat
        directionsLabel
        directionsDescription
        ctaLabel
        ctaPath
        ctaDeeplinkPath
        assetsLabel
        assetsDescription
        peopleListId
        createdAt
        updatedAt
        contentProvider {
          provider
          providerKey
        }
      }
    }
  }
`

export const CONTENT_UPDATE_MUTATION = gql`
  mutation ContentUpdate($content: ContentInput!, $language: String!, $generatePath: Boolean) {
    contentUpdate(content: $content, generatePath: $generatePath) {
      content {
        id
        titleGroupId
        titleId
        contentId
        contentType
        language
        title
        path
        published
        publishedAtDate
        unpublishedAt
        contentReferencesFrom {
          id
          contentTo(language: [$language, "_primary"]) {
            language
            titleGroupId
            title
          }
          contentReferenceType {
            id
            type
          }
        }
        episodeNumber
        seasonNumber
        contentPolicyPolicyId
        primaryLanguage
        contentSearchNoIndex
        excludeFromRecommendations
        filterType
        bundle
        displayType
        productType
        weight
        familyFriendly
        seoTitle
        seoDescription
        seoCanonicalUrl
        seoKeywords
        seoRobotsNoFollow
        seoRobotsNoIndex
        previewMediaId
        featureMediaId
        dayNumber
        productionStatus
        instructor
        director
        producer
        writer
        cast
        copyright
        studio
        descriptionFormat
        shortDescriptionFormat
        directionsLabel
        directionsDescription
        ctaLabel
        ctaPath
        ctaDeeplinkPath
        assetsLabel
        assetsDescription
        peopleListId
        createdAt
        updatedAt
      }
    }
  }
`

export const CONTENT_REFERENCE_CREATE_MUTATION = gql`
  mutation ContentReferenceCreate($contentReference: ContentReferenceCreateInput) {
    contentReferenceCreate(contentReference: $contentReference) {
      contentReference {
        id
        fromContentContentId
        fromContentContentType
        toContentContentId
        toContentContentType
        contentReferenceTypesId
      }
    }
  }
`

export const CONTENT_REFERENCE_DELETE_MUTATION = gql`
  mutation ContentReferenceDelete($contentReference: ContentReferenceDeleteInput) {
    contentReferenceDelete(contentReference: $contentReference) {
      contentReference {
        id
        fromContentContentId
        fromContentContentType
        toContentContentId
        toContentContentType
        contentReferenceTypesId
      }
    }
  }
`
